export default __webpack_public_path__ + "static/media/pgmico(44).40a154f9.png";